const TECH_TERMS = [
  'АСОБ', 'АСОУП', 'Cargo Reporting', 'ДВХ', 'DataArts', 'OBS', 'ДГР', 'ДГЭ',
  'КАР', 'ЦУП', 'STS', 'Карго', 'Гауст-ДП', 'DevSecOps', 'CI/CD', 'SDLC',
  'DEV', 'TEST', 'PROD', 'SIT', 'UAT', 'ETL', 'API', 'ИБ', 'ФНК', 'ПЛК',
];

const pattern = new RegExp(
  `(${TECH_TERMS.map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`,
  'gi',
);

export function highlightTechTerms(text: string): string {
  return text.replace(pattern, '<code class="tech-term">$1</code>');
}

export function highlightSearch(text: string, query: string): string {
  if (!query.trim()) return highlightTechTerms(text);
  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(`(${escaped})`, 'gi');
  return highlightTechTerms(text).replace(
    re,
    '<mark class="search-hit">$1</mark>',
  );
}

export function priorityBadge(priority: string): { label: string; className: string } {
  const p = (priority || '').toLowerCase();
  if (p.includes('высок')) return { label: 'Высокий', className: 'high' };
  if (p.includes('средн')) return { label: 'Средний', className: 'medium' };
  if (p.includes('низк')) return { label: 'Низкий', className: 'low' };
  return { label: priority || '—', className: 'medium' };
}
